import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { EditObject } from '../../common/constants';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import { isValidDate, validateString } from '../../common/helperFunctions';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';

export interface iState {
    validationChecked: boolean,
    message: string,
    isError: boolean
}

class Start extends React.Component<CreateSurveyProps, iState> {
    state = {
        validationChecked: false,
        message: '',
        isError: false
    }

    public componentDidUpdate() {

        if (this.props.isSubmitted === true) {
            
            if (this.props.SubmitMessage.length > 0 && this.props.SubmitMessage !== this.state.message) {
                this.setState({...this.state, message: this.props.SubmitMessage});
                
                if (this.props.errorInSubmit === false)
                    this.props.RequestSurvey(this.props.surveyId, false, true);
            }

        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.target.value = e.target.value;

        this.props.SetPropertyCreateSurvey(EditObject.Survey, e.target.name, '', false, 0, new Date(e.target.value));
    };

    handleSelectChangeNumber = (e: React.ChangeEvent<HTMLSelectElement>) => {

        this.props.SetPropertyCreateSurvey(EditObject.Survey, e.target.name, '', false, +e.target.value, new Date());
    };
    
    private SaveSurvey() {
        let msg = '';
        if (this.props.survey.newStatusId === this.props.surveyStatusPublishedId) {
        
            if (validateString(true, this.props.survey.endNotesEn, 1, -1) === false)
                msg = 'Endnote English text is missing';
            else if (validateString(true, this.props.survey.endNotesFr, 1, -1) === false)
                msg = 'Endnote French text is missing';

            else if (validateString(true, this.props.survey.name, 1, -1) === false)
                msg = 'Campaign name is missing';

            else if (validateString(true, this.props.survey.titleEn, 1, -1) === false)
                msg = 'Campaign English title is missing';
            else if (validateString(true, this.props.survey.titleFr, 1, -1) === false)
                msg = 'Campaign French title is missing';

            else if (validateString(true, this.props.survey.startNotesEn, 1, -1) === false)
                msg = 'Startnote English text is missing';
            else if (validateString(true, this.props.survey.startNotesFr, 1, -1) === false)
                msg = 'Startnote French text is missing';
            
            else if (this.props.survey.questions.length === 0)
                msg = 'Please add at least one question';
        }

        else if (isValidDate(this.props.survey.startDate) === false || this.props.survey.startDate < new Date(2000, 1, 1))
            msg = 'Survey start date cannot be before Jan 2000';
        else if (isValidDate(this.props.survey.endDate) === false || this.props.survey.endDate < this.props.survey.startDate)
            msg = 'Survey end date must be greater than start date';


        if (msg.length === 0) {
            this.setState({...this.state, 
                validationChecked: true,
                message: '',
                isError: false});

            this.props.SaveSurvey();
        } else {
            this.setState({...this.state, 
                validationChecked: true,
                message: msg,
                isError: true});
        }
    }

    render() {
        return(
            <React.Fragment>
                <div className="form-grouX">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Status <samp className="text-danger">&nbsp;*</samp></label>
                        <select className="form-select"
                                onChange={this.handleSelectChangeNumber}
                                defaultValue={this.props.survey.newStatusId}
                                disabled={this.props.survey.statusId === this.props.surveyStatusPublishedId}
                                name='newStatusId'>
                            {this.props.surveyStatusList.map((t) => { return(<option key={t.id} value={t.id}>{t.name}</option>) })}
                        </select>
                        {this.props.survey.newStatusId === this.props.surveyStatusPublishedId && <div className="invalid-feedback d-block pt-1 pb-2">Please note that you won't be able to make anychanges once published</div>}
                    </div>
                </div>
                <div className="form-grouX">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">Start Date <samp className="text-danger">&nbsp;*</samp></label>
                        <input type="datetime-local"
                            className="form-control"
                            defaultValue={this.props.survey.startDate.toString()}
                            onChange={this.handleChange}
                            name='startDate'
                            required></input>
                        
                    </div>
                </div>
                <div className="form-grouX">
                    <div className='col-sm-12 col-md-6'>
                        <label className="form-label fw-bold">End Date <samp className="text-danger">&nbsp;*</samp></label>
                        <input type="datetime-local"
                            className="form-control"
                            defaultValue={this.props.survey.endDate.toString()}
                            onChange={this.handleChange}
                            name='endDate'
                            required></input>
                    </div>
                </div>

            {
                this.state.validationChecked &&

                <div className="form-grouX">
                    <div className='col-sm-12'>
                        <div className={ (this.props.errorInSubmit || this.state.isError) ? "invalid-feedback d-block pt-1 pb-2" : "valid-feedback d-block pt-1 pb-2"}>{this.state.message}</div>
                    </div>
                </div>
            }
                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                    <button className="btn btn-primary" onClick={() => this.SaveSurvey()}>Save</button>
                    <Link className="btn btn-outline-danger float-end" to={'/search'}>Cancel and goto campaign list</Link>
                </div>

            </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Start as any);

